import { GenericProps } from "../../types";
import { UsersTable } from "./UsersTable";

export function Users(props: GenericProps) {

    return <div className="users">

        <UsersTable {...props} />

    </div>

}

